import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IBilling } from "../../../Pages/Role/IRole";

export const ListBillingSlice = createSlice({
  name: "ListBillingSlice",
  initialState: {} as IReduxState<IBilling[]>,
  reducers: {
    listBilling: (state) => {
      state.isLoading = true;
    },
    successlistBilling: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistBilling: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failurelistBilling, listBilling, successlistBilling } =
  ListBillingSlice.actions;

export default ListBillingSlice.reducer;
